/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_A_DInputs */

const en_wc_start_a_d = /** @type {(inputs: Wc_Start_A_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click “Try WordCraft here” at the top of this page to load the browser editor. For offline writing, choose a desktop build from the download guide.`)
};

/**
* | output |
* | --- |
* | "Click “Try WordCraft here” at the top of this page to load the browser editor. For offline writing, choose a desktop build from the download guide." |
*
* @param {Wc_Start_A_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_a_d = /** @type {((inputs?: Wc_Start_A_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_A_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_a_d(inputs)
});
export { wc_start_a_d as "wc.start.a_d" }